import { Helmet } from 'react-helmet-async';

export function SEO({ 
  title = "DayCal - The better way to schedule your meetings", 
  description = "DayCal simplifies appointment scheduling. Share your custom booking link, sync calendars, collect payments, and automate form questions — seamlessly.", 
  path = "/",
  image = "https://daycal.in/og-image.jpg"
}) {
  const url = `https://daycal.in${path}`;

  return (
    <Helmet>
      {/* Standard SEO */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={url} />

      {/* OpenGraph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
